import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { Cliente } from 'src/app/model/cliente.model';
import { Contrato } from 'src/app/model/contrato.model';
import { AlertService } from 'src/app/service/alert.service';
import { ClientesService } from 'src/app/service/clientes.service';
import { ContratosService } from 'src/app/service/contratos.service';
import { ProdutosService } from 'src/app/service/produtos.service';

@Component({
  selector: 'app-atualizar-contrato',
  templateUrl: './atualizar-contrato.component.html',
  styleUrls: ['./atualizar-contrato.component.css']
})
export class AtualizarContratoComponent implements OnInit {

  constructor(private serviceClientes: ClientesService,
    private router: Router,
    private produtoService: ProdutosService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private service: ContratosService,
    private alertService: AlertService,) {
    this.form = this.formBuilder.group({
      ts_data_vencimento: new FormControl('', [Validators.required]),
      fk_produto: new FormControl('', [Validators.required]),
      fk_cliente: new FormControl('', [Validators.required]),
      ts_data: new FormControl(''),
    })
  }

  tipoData: any;
  clientes!: Cliente[];
  load = false;
  value = 50;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  form!: FormGroup;
  produtos = [] as any
  contrato: Contrato = {
    sr_id: '',
    ts_data_vencimento: '',
    ts_renovado_em: '',
    ts_cancelado_em: '',
    vc_observacao: '',
    fk_cliente: '',
    fk_produto: '',
    fk_contrato_renovacao: '',
  };

  ngOnInit(): void {
    this.listarClientes();
    this.listarProdutos();
    this.listarPorId();
  }

  listarPorId(): void {
    this.service.listarIdService(this.activatedRoute.snapshot.paramMap.get('sr_id')).subscribe((resp: any) => {
      this.form.get("ts_data_vencimento")?.setValue(new Date(resp.ts_data_vencimento).toISOString())
      this.form.get("fk_produto")?.setValue(resp.fk_produto)
      this.form.get("fk_cliente")?.setValue(resp.fk_cliente)
      if (resp.ts_cancelado_em != null) {
        this.form.get("ts_data")?.setValue(new Date(resp.ts_cancelado_em).toISOString())
        this.tipoData = 'Data do cancelamento:';
      } else if (resp.ts_renovado_em != null) {
        this.form.get("ts_data")?.setValue(new Date(resp.ts_renovado_em).toISOString())
        this.tipoData = 'Data da renovação:';
      }
    })
  }

  listarClientes() {
    this.serviceClientes.listarServiceClientes().subscribe(resp => {
      this.clientes = resp;
    })
  }

  listarProdutos() {
    this.produtoService.listarService().subscribe((resp: any) => {
      this.produtos = resp.filter(function (elem: any) {
        return elem.sr_id != 1
      })
    }, error => {

    })
  }

  cancel() {
    this.router.navigate(['configuracao/contratos']);
  }

  atualizar() {
    this.form.value.sr_id = this.activatedRoute.snapshot.paramMap.get('sr_id');
    if (typeof this.form.value.ts_data_vencimento == 'string') {
      this.form.value.ts_data_vencimento = this.form.value.ts_data_vencimento.replace(/T/, " ").replace(/\..+/, "")
    } else {
      this.form.value.ts_data_vencimento = this.form.value.ts_data_vencimento.toISOString().replace(/T/, " ").replace(/\..+/, "")
    }
    if (this.form.value.ts_data != '' && typeof this.form.value.ts_data == 'string') {
      this.form.value.ts_data = this.form.value.ts_data.replace(/T/, " ").replace(/\..+/, "")
    } else if (this.form.value.ts_data != '' && typeof this.form.value.ts_data != 'string') {
      this.form.value.ts_data = this.form.value.ts_data.toISOString().replace(/T/, " ").replace(/\..+/, "")
    }
    this.service.atualizarService(this.form.value).subscribe((resp) => {
      this.alertService.success();
      this.router.navigate(['configuracao/contratos']);
    }, error => {
      this.alertService.error(error);
    }
    )
  }
}
